export default "__VITE_ASSET__pjjWJPUS__"